import { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './CardFooter.module.scss';

interface Props {
  children?: ReactNode;
  className?: string;
}

export const CardFooter = ({ children, className = '' }: Props) => {
  return <section className={classNames(styles.cardFooter, className)}>{children}</section>;
};
